<template>
  <div class="faq-block">
    <div class="faq-block-content">
      <div class="section-view-title">
        <div class="section-view-title-content">
          Есть вопросы по сайту или<br />
          условиям работы?
        </div>
      </div>
      <div class="faq-block-text">
        Специально для таких случаев мы собрали максимально подробную базу знаний,<br />
        в которой содержатся самые распространенные вопросы и ответы на них.
      </div>
      <div class="faq-block-header">
        <div class="faq-block-title">
          Например
        </div>
        <div class="faq-block-button faq-block-button--desktop">
          <a href="/faq" class="btn-main btn-big">
            <span class="btn-main-overlay">
              <span class="btn-main-content">
                Перейти в раздел Помощь
              </span>
            </span>
            <span class="btn-main-shadow"></span>
          </a>
        </div>
      </div>
      <flickity class="faq-slider" ref="flickity" :options="options">
        <div class="faq-slider-slide" v-for="item in list">
          <div class="faq-slide">
            <a :href="'/node/' + item.id" class="faq-card">
              <div class="faq-card-content">
                <div class="faq-card-title">
                  {{ item.title }}
                </div>
                <div class="faq-card-intro">
                  {{ item.text }}
                </div>
                <div class="faq-teaser-stats">
                  <div class="faq-teaser-stat faq-teaser-stat--hits">
                    {{ item.views }}
                  </div>
                  <div class="faq-teaser-stat faq-teaser-stat--likes">
                    {{ item.likes }}
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </flickity>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FrontFaq',
  data() {
    return {
      list: [],
      options: {
        contain: true,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left'
      }
    }
  },
  created() {
    axios.get('/faq/get-frontpage-list').then((response) => {
      this.list = response.data.list || [];
      this.$nextTick(() => {
        this.$refs.flickity.rerender();
      });
    });
  }
}
</script>